export const ADD_FILTER = "ADD_FILTER";

export const addFilter = state => ({
  type: ADD_FILTER,
  input: state.input,
  value: state.value
});
